import * as R from 'ramda';
import { mapProps } from 'recompose';
import Media from 'components/general/Media/Media';
import prependAssetRoot from 'utils/prependAssetRoot';

const applySpec = R.applySpec({
  title: R.prop('title'),
  category: R.always({
    title: 'ARTICLES',
    href: {
      type: 'ARTICLES_INDEX',
    },
  }),
  href: R.pipe(
    R.prop('slug'),
    slug => ({
      type: 'ARTICLES_SINGLE',
      payload: { slug },
    }),
  ),
  date: R.prop('date'),
  summary: R.prop('synopsis'),
  author: R.pipe(
    R.prop('editor'),
    R.applySpec({
      name: R.prop('name'),
      photo: R.pipe(
        R.prop('photo'),
        prependAssetRoot,
      ),
    }),
  ),
  small: R.prop('small'),
});

/**
 * A `Media` component with props pre-mapped for articles. Just for convenience
 * when re-using `Media` with articles across views.
 */
const ArticleSummary = mapProps(props => (
  R.pipe(
    applySpec,
    R.omit(props.hide || []),
  )(props)
))(Media);

export default ArticleSummary;

